// ** React Imports
import { Fragment, useEffect, useRef, useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { makeStyles } from "@mui/styles";
import { useDropzone } from 'react-dropzone'
import { convertBase64, ConvertDateTime, getUserData, s3Client, } from '../../../Base/helper/baseFunctions';
import Loading from "../../images/recruitment.gif";
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import ErrorIcon from '@mui/icons-material/Error';
import { Backdrop, CircularProgress, Divider, FormControl, FormHelperText, FormLabel, IconButton, InputLabel, ListSubheader, MenuItem, Select } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";
import { UploadResumeAction } from '../../../../../store/ATS/Resume/Action';
import { GetCandidateSourceAction } from '../../../../../store/ATS/CandidateSource/Action';
import { LabelWithInfo } from "../../../Base/views/LabelwithInfo";
import Warning from "../../images/report.png";
import Popup from "../../../Base/views/Popup";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import { AtsArchiveResumeHelper, GetAtsFailedResumeHelper, AddAtsBulkResumeHelper } from '../../helper/AtsResumeParserHelper'
import MaterialTable from 'material-table'
import { PythonResetApiAction } from '../../../../../store/ATS/PythonApi/Action'
import AICongifWarningPopup from '../../helper/Ancillary/AICongifWarningPopup'

const Alert = () => {
  const containerStyle = {
    borderRadius: "5px",
    display: "flex",
    alignItems: "start",
    justifyContent: "space-between",
    padding: "10px 15px",
    color: "#000",
    position: "relative",
  };

  const infoIconStyle = {
    color: "#007bff",
    display: "flex",
    alignItems: "start",
    fontSize: "18px",
  };

  const textStyle = {
    margin: 0,
    flex: 1,
    color: "#1b1c21"
  };

  return (
    <div style={{ width: "100%", textAlign: "center", display: "flex", justifyContent: "center" }}>
      <div style={containerStyle}>
        <span style={infoIconStyle}><ErrorIcon /></span>
        <div>
          <p style={textStyle}>
            You can only upload up to 50 files.
          </p>
          <p style={{ ...textStyle, marginTop: 2, fontSize: "12px" }}>
            Only .pdf and .docx files are accepted.
          </p>
        </div>
          
       
      </div>
    </div>
  );
};

const uploadButtonStyles = {
  display: "inline-block",
  padding: "10px 20px",
  backgroundColor: "#8b44ff",
  color: "#fff",
  borderRadius: "5px",
  cursor: "pointer",
  marginRight: "10px",
};

const Img = styled('img')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    marginRight: theme.spacing(15.75)
  },
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(4)
  },
  [theme.breakpoints.down('sm')]: {
    width: 160
  }
}))

const HeadingTypography = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(4)
  }
}))

const ResumeUploader = ({ id }) => {
  const useStyles = makeStyles((theme) => ({
    files: {
      display: 'flex',
      justifyContent: 'space-between',
      borderRadius: '6px',
      padding: '0.625rem 0.6rem 0.625rem 1.5rem',
      border: '1px solid rgba(93, 89, 98, 0.14)',
      marginTop: '1.5625rem'
    },
    button: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '1rem',
      paddingBottom: '1.25rem'
    },
    Backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      position: "absolute",
      borderRadius: "inherit",
      backdropFilter: "blur(2px)",
      WebkitBackdropFilter: 'blur(2px)',
    },
  }));
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isParsing, GetSuccess } = useSelector(state => state.AtsReducer?.AtsPythonApiReducer)
  const { isUploading } = useSelector(state => state.AtsReducer?.AtsUploadReducer)
  const [files, setFiles] = useState([]);
  const [load, setLoad] = useState(false);
  const [failed_files, setFailedFiles] = useState([]);
  const [show, setShow] = useState(false);
  const aiConfigPopupRef = useRef();
  const { AiConfigLoading, ModelTestingLoading } = useSelector(
    (state) => state.AncillaryReducer?.AIConfigReducer
  );
  
  const userData = getUserData();
  const ALLOWED_TYPES = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // docx
  ];

  const { candidateSourceData } = useSelector((state) => state.AtsReducer?.CandidateSourceReducer || {});
  const candidateSourceList = Array.isArray(candidateSourceData) ? candidateSourceData?.filter((el) => !el?.is_default) : [];
  const [selectedSource, setSelectedSource] = useState("");
  const [sourceError, setSourceError] = useState("");

  useEffect(() => {
    dispatch(GetCandidateSourceAction());
  }, [dispatch]);

  useEffect(() => {
    if (GetSuccess === "Success" && id) {
      setLoad(false)
      dispatch(PythonResetApiAction());
      GetAtsFailedResumeHelper().then((res) => {
        setFailedFiles(res?.data?.data)
      });
    } else {
      setLoad(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [GetSuccess, id]);

  useEffect(() => {
    GetAtsFailedResumeHelper().then((res) => {
      setFailedFiles(res?.data?.data)
    });
    if (aiConfigPopupRef.current) {
      aiConfigPopupRef.current.validateAIConfig();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleUpload = async () => {
    if (!selectedSource && selectedSource !== "General") {
      setSourceError("Candidate Source is required");
      toast.dismiss();
      toast.error("Please select a candidate source");
      return;
    }
    setSourceError("");
    setLoad(true);
    try {
      setFiles([]);
      await AtsArchiveResumeHelper();
      let b64Files = [];
      let fileNames = [];
      let contentTypes = [];
      let file_data = [];
      for (let i = 0; i < files?.length; i++) {
        const file = files[i];
        const b64string = await convertBase64(file);
        const ext = file?.name?.split(".").at(-1);
        const content_type = ext === "pdf" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        const filename = `${userData?.domain}/Staging/ATS/Resumes/` + uuidv4() + "." + ext;
        b64Files.push(b64string);
        fileNames.push(filename);
        contentTypes.push(content_type);
        const extracted_filename = filename.split('/').pop();
        file_data.push({
          original_filename: file?.name,
          encrypt_filename: extracted_filename,
          digitalocean_filename: filename
        });
      }
      const data = {
        files: fileNames,
        workspace_name: [userData?.domain],
        user_id: [userData?.ats_user_id],
        job_id: [id],
        consultancy_id: [userData?.user_type === "Consultancy" ? userData?.consultancy_id : "0"],
        source_id: (selectedSource && selectedSource !== "General") ? [selectedSource] : [],
        candidate_source_configuration_fk: (selectedSource && selectedSource !== "General") ? selectedSource : null
      };
      AddAtsBulkResumeHelper({
        file_data: file_data
      });

      dispatch(UploadResumeAction({ b64Files, fileNames, data, contentTypes }, dispatch));
      (!isUploading && !isParsing) && setFiles([])
    } catch (error) {
      console.error("Error during file upload: ", error);
    }
  };

  const handleFolderChange = async (event) => {
    setFiles([]);
    event.preventDefault();
    const selectedFiles = event.target.files;
    const filesArray = Array.from(selectedFiles);
    const validFiles = [];
    filesArray?.forEach((file) => {
      if (ALLOWED_TYPES.includes(file.type)) {
        validFiles.push(file);
      } else {
        setShow(true);
      }
    });
    if (validFiles?.length > 50) {
      toast.error('You can only upload up to 50 files.', {
        duration: 2000
      });
    } else {
      setFiles(validFiles);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    noClick: isParsing,
    maxFiles: 50,
    maxSize: 20000000,
    onDrop: acceptedFiles => {
      acceptedFiles.forEach(file => {
        if (!id) {
          if (ALLOWED_TYPES.includes(file.type)) {
            setFiles(files => [...files, Object.assign(file)])
          }
          else {
            setShow(true);
          }
        }
        else {
          if (ALLOWED_TYPES.includes(file.type)) {
            setFiles(acceptedFiles.map(file => Object.assign(file)));
          }
          else {
            setShow(true);
          }
        }
      });
    },
    onDropRejected: () => {
      toast.error('You can only upload up to 50 files.', {
        duration: 2000
      })
    }
  })
  const handleRemoveAllFiles = () => {
    setFiles([])
  }
  const HandleClose = () => {
    setShow(false);
    // setFiles([]);
  };
  const handleView = async (event, rowData) => {
    event.stopPropagation();
    const bucketParams = {
      Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
      Key: rowData?.error_file_path,
    };
    try {
      const url = await getSignedUrl(
        s3Client,
        new GetObjectCommand(bucketParams),
        { expiresIn: 3 * 60 }
      );
      if (url) {
        window.open(url, "_blank");
      }
    } catch (err) {
      toast.error(err.message || "An error occurred while opening the document.");
    }
  };
  return (
    <Fragment>
      <Box  sx={{ position: "relative", width: "100%", minHeight: "100%", pt: 1 }}>
        <Backdrop className={classes.Backdrop} open={AiConfigLoading || ModelTestingLoading}>
          <CircularProgress />
        </Backdrop>
        <Popup
          maxWidth="xs"
          openPopup={show}
          setOpenPopup={setShow}
          close={false}
          hideDividers={true}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
              <img src={Warning} alt="UnSupport File" width={"25%"} />
            </Box>
            <FormControl>
              <FormLabel id="gender-label">
                <Typography variant="h5" className="blink">
                  Invalid File Type, Accepted file type is .pdf and .docx
                </Typography>
              </FormLabel>
            </FormControl>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "10px",
              }}
            >
              <Button
                onClick={HandleClose}
                variant="contained"
                type="submit"
                className="mpl-primary-btn profile-btn"
                size="small"
                sx={{
                  margin: "10px",
                }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Popup>
        {
          (load || isParsing || isUploading) &&
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',  // Full height of the viewport
            backgroundColor: '#f0f4f8'  // Optional: Set a background color
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '10px'
            }}>
              <Typography sx={{ mb: 2 }} variant='h4'>Your files are Parsing, we'll notify you once it's completed.</Typography>
              <img
                src={Loading}
                alt="Loading..."
                width={"150px"}
                height={"150px"}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  padding: "10px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
          </div>
        }
        {!(load || isParsing || isUploading) && (
          <>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 2, px: 1 }}>
              <FormControl size="small" sx={{ minWidth: 240 }} error={Boolean(sourceError)} required>
                <InputLabel id="candidate-source-label">Candidate Source</InputLabel>
                <Select
                  labelId="candidate-source-label"
                  id="candidate-source-select"
                  value={selectedSource || ""}
                  label="Candidate Source *"
                  onChange={(e) => {
                    setSelectedSource(e.target.value);
                    if (sourceError) setSourceError("");
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300,
                        minWidth: "180px",
                      },
                    },
                  }}
                >
                  <ListSubheader
                    sx={{
                      fontWeight: 600,
                      color: "text.primary",
                      lineHeight: "40px",
                    }}
                  >
                    <LabelWithInfo
                      variant="body2"
                      style={{ fontWeight: 600 }}
                      label="Select Candidate Source"
                      tooltip="Select where the candidate applied from. Need more options? Add candidate sources from Settings."
                    />
                  </ListSubheader>
                  <MenuItem value="General">
                    General (No Source)
                  </MenuItem>
                  {candidateSourceList?.map((item) => {
                    const sourceName = item?.source_name;
                    if (!sourceName) return null;
                    return (
                      <MenuItem
                        key={item?.candidate_source_configuration_pk}
                        value={item?.candidate_source_configuration_pk}
                      >
                        {sourceName}
                      </MenuItem>
                    );
                  })}
                </Select>
                {sourceError && <FormHelperText error>{sourceError}</FormHelperText>}
              </FormControl>
            </Box>
            <div {...getRootProps({ className: 'dropzone' })}>
              <input {...getInputProps()} />
              <Box sx={{ display: 'flex', flexDirection: ['column', 'column', 'row'], alignItems: 'center', justifyContent: 'center' }}>
                <Img alt='Upload img' src='https://meepldevstorage.nyc3.digitaloceanspaces.com/meepl-assets/resume_uploader_img.png' />
                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: ['center', 'center', 'inherit'] }}>
                  <HeadingTypography variant='h5'>Drop files here or click to upload.</HeadingTypography>
                  <Typography color='textSecondary' sx={{ '& a': { color: 'primary.main', textDecoration: 'none' } }}>
                    Drop files here or click{' '}
                    <a href='/' onClick={e => e.preventDefault()}>
                      browse
                    </a>{' '}
                    through your machine
                  </Typography>
                </Box>
              </Box>
            </div>
            <Alert />
            <Box
              sx={{
                display: "flex",
                flexDirection: ["column", "column", "row"],
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <input
                type="file"
                id="folderInput"
                webkitdirectory=""
                directory=""
                onChange={handleFolderChange}
                style={{ display: "none" }}
              />
              <label htmlFor="folderInput" style={uploadButtonStyles}>
                Upload Folder
              </label>
            </Box>
          </>
        )}
        {files?.length ? (
          <Fragment>
            <Typography sx={{ display: 'flex', justifyContent: 'end', pr: '25px', fontSize: '1.1rem', fontWeight: 700, color: 'black' }}>No of resumes : {files?.length}</Typography>
            <div className={classes.button}>
              <Button style={{ marginRight: '0.85rem' }} color='error' variant='outlined' onClick={handleRemoveAllFiles}>
                Remove All
              </Button>
              <Button style={uploadButtonStyles} variant='contained' onClick={() => {
                handleUpload();
              }}>Upload Files</Button>
            </div>
          </Fragment>
        ) : null}

        {(failed_files?.length > 0 && !(load || isParsing || isUploading)) && (
          <>
            <Divider sx={{ marginBottom: "20px" }} />
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "70%", maxWidth: "1000px" }}>
                <MaterialTable
                  columns={[
                    { title: "File Name", cellStyle: { padding: "10px 10px 10px 13px" }, field: "original_file_name", grouping: false },
                    {
                      title: "Upload Date", cellStyle: { padding: "10px 10px 10px 13px" }, field: "upload_date", render: (rowData) => {
                        return ConvertDateTime(rowData.upload_date);
                      }, grouping: false
                    },
                    {
                      title: "View Resume",
                      cellStyle: { padding: "0px 0px 0px 30px", },
                      render: rowData => (
                        <div>
                          {rowData.error_file_path && (
                            <IconButton
                              onClick={(e) => handleView(e, rowData)}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          )}
                        </div>
                      ),
                    },
                  ]}
                  data={failed_files || []}
                  options={{
                    maxBodyHeight: "59vh",
                    minBodyHeight: "59vh",
                    rowStyle: { fontSize: "13px" },
                    sorting: false,
                    search: true,
                    searchText: "",
                    searchFieldAlignment: "right",
                    searchAutoFocus: true,
                    searchFieldVariant: "standard",
                    filtering: false,
                    paging: true,
                    pageSizeOptions: [25, 50],
                    pageSize: 25,
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    paginationPosition: "bottom",
                    exportButton: false,
                    exportAllData: true,
                    exportFileName: "Client",
                    addRowPosition: "first",
                    selection: false,
                    actionsColumnIndex: -1,
                    showSelectAllCheckbox: true,
                    showTextRowsSelected: true,
                    grouping: false,
                    columnsButton: false,
                    draggable: false
                  }}

                  title="Failed Resumes"

                />
              </div>
            </div>
          </>
        )}

        <AICongifWarningPopup ref={aiConfigPopupRef} validateFor="Resume"  />
      </Box>
    </Fragment>
  )
}
export default ResumeUploader
